import Vue from "vue";
import VueRouter from "vue-router";

import Home from "./views/Home";
import Test from "./views/Test";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: "/web/4g/test",
      name: "Test",
      component: Test
    },
    {
      path: "*",
      name: "catchall",
      component: Home
    }
  ]
});

export default router;
